export const SEARCH_SECTION_LOAD_MORE_PREFIX = 'loadMore';
export const SEARCH_SECTION_TYPE_BALANCES = 'balances';
export const SEARCH_SECTION_TYPE_RESULTS = 'searchResults';
export const SEARCH_SECTION_TYPE_TRENDING_TOKENS = 'trendingTokens';
export const SEARCH_SECTION_TYPE_RECENTLY_VIEWED = 'recentlyViewed';
